/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Event_Duration_LabelInputs */

const en_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Duration`)
};

const fr_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duree d'evenement`)
};

const de_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisdauer`)
};

const it_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata dell'evento`)
};

const ru_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность события`)
};

const es_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración del evento`)
};

const zh_cn2_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件持续时间`)
};

const ja_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント期間`)
};

const hi_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम की अवधि`)
};

const pt_pt2_style_guide_manager_event_duration_label = /** @type {(inputs: Style_Guide_Manager_Event_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração do evento`)
};

/**
* | output |
* | --- |
* | "Event Duration" |
*
* @param {Style_Guide_Manager_Event_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_event_duration_label = /** @type {((inputs?: Style_Guide_Manager_Event_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Event_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_event_duration_label(inputs)
	if (locale === "de") return de_style_guide_manager_event_duration_label(inputs)
	if (locale === "it") return it_style_guide_manager_event_duration_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_event_duration_label(inputs)
	if (locale === "es") return es_style_guide_manager_event_duration_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_event_duration_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_event_duration_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_event_duration_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_event_duration_label(inputs)
	return en_style_guide_manager_event_duration_label(inputs)
});